
// 卡券弹框组件
import CouponModal from '@/components/CouponModal'

export default {
    name: 'CouponCard',
    props: {
        type: {
            // show-个人中心展示 / select-下单前选择
            type: String,
            default: 'show'
        },
        detailsInfo: {
            type: Object,
            default: {}
        },
        selectCouponFun: {
            type: Function
        },
        showScopeBusinessTag: {
            type: Boolean,
            default: false
        },
        useExposureCoupon: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            couponDescriptionModalShow: false
        }
    },
    computed: {
        btnText() {
            if (this.useExposureCoupon) {
                return '使用'
            }
            return this.isUsed ? '已使用' : '去使用'
        },
        // 是否为下单前选择的卡券， 否则是个人中心展示的
        isSelectCard() {
            return this.type === 'select'
        },
        // 当前可使用的卡券
        isUseless() {
            return this.detailsInfo?.canUse
        },
        // 未使用的优惠券
        isNoUse() {
            return Number(this.detailsInfo?.couponsStatus) === 0
        },
        // 已使用的卡片
        isUsed() {
            return Number(this.detailsInfo?.couponsStatus) === 1
        },
        // 已失效的卡片
        isInvalid() {
            return Number(this.detailsInfo?.couponsStatus) === 2
        },
        // 是否展示用券时间（券可用 || 过期失效的券）
        isShowCouponDate() {
            return this.isNoUse || (this.isInvalid && !this.detailsInfo?.cancelStatus)
        },
        // 券使用时间提示
        useDateTips() {
            if (this.detailsInfo?.timeLineStatus === 0) {
                return `${this.detailsInfo?.useStartTime} 后可用`
            } else {
                // 过期失效的券（不是作废失效）
                if (this.isInvalid && !this.detailsInfo?.cancelStatus) {
                    return `${this.detailsInfo?.useEndTime} 到期`
                }
                return `${this.detailsInfo?.useEndTime} 到期`
            }
        },
        couponsIntroduceList() {
            const parts = this.detailsInfo.couponsIntroduce?.split('\n') || [] // 根据 \n 分割
            if (parts.length > 2) {
                parts[1] = parts.slice(1).join('\n') // 将多余的内容合并到第二项
                return parts.slice(0, 2) // 保留前两项
            }
            return parts
        },
        /**
         * 优惠券类型名称
         */
        scopeBusinessName() {
            const map = {
                1: '包赔券',
                2: '订单券',
                3: '曝光券'
            }
            return map[this.detailsInfo?.scopeBusiness] || ''
        },
        /**
         * 根据优惠券类型获取不同的标签背景
         */
        tagBg() {
            const map = {
                1: 'linear-gradient(82deg, #ffc18b 1.47%, #fd3535 88.11%)',
                2: 'linear-gradient(82deg, #8BCBFF 1.47%, #4B84FF 88.11%)',
                3: 'linear-gradient(82deg, #FBD482 1.47%, #FF882D 88.11%)'
            }
            return map[this.detailsInfo?.scopeBusiness] || ''
        },

        // 可使用的平台
        // scopeClient() {
        // 	return JSON.parse(this.detailsInfo?.scopeClientExplain || '[]').join('、')
        // }
    },
    methods: {
        closeModal() {
            this.couponDescriptionModalShow = false
        },
        async toUseCoupon(e) {
            // 我的券包-待使用-未到使用日期不可用
            if (!this.isSelectCard && !this.isUseless) {
                return
            }
            // 已使用的卡片
            if (this.isUsed) {
                return
            }
            if (this.useExposureCoupon) {
                try {
                    const data = {
                        couponsCode: e.couponsCode,
                        ...this.$route.query
                    }
                    const res = await this.$api.useExposureCoupon(data)
                    if (!res.success)
                        return this.$message.error(res.info)
                    this.$message.success('使用成功')
                    this.$router.back()
                }
                catch (error) {
                    this.$message.error(error.message)
                }
                return
            }
            if (this.detailsInfo?.scopeBusiness !== 3) {
                this.$router.push('/gameList')
            } else {
                this.$router.push('/account/sellerList')
            }
        }
    }
}
